import useTranslation from "@/hooks/useTranslation";
import Button from "@material-ui/core/Button";
import React, { useState } from "react";
import CreateCollectionDialog from "./components/CreateCollectionDialog";

interface IProps {
  refresh: () => void;
}

const CreateCollectionCard: React.FC<IProps> = ({ refresh }) => {
  const { t } = useTranslation("bundle");
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {t("collection.create.itself")}
      </Button>
      <CreateCollectionDialog
        open={open}
        handleClose={handleClose}
        refresh={refresh}
      />
    </div>
  );
};

export default CreateCollectionCard;
